import { adminConstants } from "../constant/admin-constant";
import { alertActions } from "./alert-actions";
import { history } from "../../helper/history";
import { userService } from "../../services/user";
import { listService } from "../../services/lists";

export const listActions = {
    updatePermission,
    getList,
    getListItem,
    storeList,
    editList,
    deleteList
};

function updatePermission(userId) {
    return dispatch => {
        dispatch(request());
        userService.updatePermission(userId).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function () {
                    history.go(0);
                }, 500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.CHANGE_PRIMARY_USER_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_FAILURE,
            payload: error
        };
    }
}

// function getAllListTypes() {
//     return dispatch => {
//         dispatch(request())
//         listService.getAllListTypes()
//             .then(
//                 response => {
//                     dispatch(success(response));
//                 },
//                 error => {
//                     dispatch(failure(error));
//                     dispatch(alertActions.error(error));
//                 }
//             );
//     };

//     function request() { return { type: adminConstants.GET_ALL_LIST_TYPES_REQUEST } }
//     function success(response) { return { type: adminConstants.GET_ALL_LIST_TYPES_SUCCESS, payload: response } }
//     function failure(error) { return { type: adminConstants.GET_ALL_LIST_TYPES_FAILURE, payload: error } }
// }

function getList(list_name, page, filter, sort, pageSize, component_name, pagination) {
    return dispatch => {
        dispatch(request());
        return listService
            .getList(
                list_name,
                page,
                filter,
                sort,
                pageSize,
                component_name,
                pagination
            )
            .then(
                list => {
                    dispatch(success(list));
                    return list.result;
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                    return Promise.reject(error);
                }
            );
    };
    function request() {
        return { type: adminConstants.GET_LIST_REQUEST };
    }
    function success(list) {
        return { type: adminConstants.GET_LIST_SUCCESS, payload: list };
    }
    function failure(error) {
        return { type: adminConstants.GET_LIST_FAILURE, payload: error };
    }
}

function getListItem(id) {
    return dispatch => {
        dispatch(request());
        return listService.getListItem(id).then(
            list => {
                dispatch(success(list));
                return list.result.list;
            },
            error => {
                //dispatch(failure(error));
                //dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.GET_LIST_ITEM_REQUEST };
    }
    function success(list) {
        return { type: adminConstants.GET_LIST_ITEM_SUCCESS, payload: list };
    }
    // function failure(error) {
    //     return { type: adminConstants.GET_LIST_ITEM_FAILURE, payload: error };
    // }
}

function storeList(listData) {
    return dispatch => {
        dispatch(request());
        return listService.storeList(listData).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return listData;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_LIST_ITEM_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.STORE_LIST_ITEM_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return { type: adminConstants.STORE_LIST_ITEM_FAILURE, payload: error };
    }
}

function deleteList(list_id) {
    return dispatch => {
        dispatch(request());
        return listService.deleteList(list_id).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.DELETE_LIST_ITEM_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.DELETE_LIST_ITEM_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.DELETE_LIST_ITEM_FAILURE,
            payload: error
        };
    }
}

function editList(listData, list_id) {
    return dispatch => {
        dispatch(request());
        return listService.editList(listData, list_id).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return listData;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.EDIT_LIST_ITEM_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.EDIT_LIST_ITEM_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return { type: adminConstants.EDIT_LIST_ITEM_FAILURE, payload: error };
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/list-actions.jsx